import React from 'react';
import { Ruler, FileText, ClipboardCheck, Wrench, TestTube, Smartphone } from 'lucide-react';
export function InstallationStepsSection() {
  const steps = [{
    icon: Ruler,
    title: '1. Site Assessment',
    description: 'We visit your property to measure, photograph, and evaluate electrical/mechanical capacity. You get a written scope document.',
    duration: '1-2 hours',
    deliverable: 'Site assessment report'
  }, {
    icon: FileText,
    title: '2. Design & Planning',
    description: 'We create a custom layout plan showing cable/tubing placement, electrical/mechanical requirements, and controls configuration.',
    duration: '3-5 business days',
    deliverable: 'Layout plan + fixed-scope quote'
  }, {
    icon: ClipboardCheck,
    title: '3. Pre-Install Walkthrough',
    description: 'Before any work begins, we walk the site with you. We confirm the plan, mark boundaries, discuss access/staging, and answer final questions.',
    duration: '30-60 min',
    deliverable: 'Signed-off plan'
  }, {
    icon: Wrench,
    title: '4. Installation',
    description: 'Our certified crew installs the heating system. We document cable/tubing placement with photos before covering.',
    duration: '1-3 days (varies)',
    deliverable: 'Progress photos + daily updates'
  }, {
    icon: TestTube,
    title: '5. Testing & Commissioning',
    description: 'We run continuity and megger tests (electric) or pressure tests (hydronic) to verify every circuit. Results are documented.',
    duration: '2-4 hours',
    deliverable: 'Test results report'
  }, {
    icon: Smartphone,
    title: '6. Handoff & Demo',
    description: 'We walk you through the controls, show you the app, explain seasonal startup/shutdown, and hand over all documentation.',
    duration: '30-60 min',
    deliverable: 'Owner manual + warranty docs'
  }];
  return <section id="installation-steps" className="py-16 bg-white md:py-24" data-id="element-517">
      <div className="container mx-auto px-4 md:px-6" data-id="element-518">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-519">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-520">
            A Clear Path from Start to Finish
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-521">
            We've refined our process to minimize disruption and keep you
            informed every step of the way.
          </p>
        </div>

        <div className="max-w-4xl mx-auto relative" data-id="element-522">
          {/* Vertical Line */}
          <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-slate-200 hidden md:block" data-id="element-523"></div>

          <div className="space-y-12" data-id="element-524">
            {steps.map((step, index) => <div key={index} className="relative flex flex-col md:flex-row gap-8 md:gap-12 group" data-id="element-525">
                {/* Icon Circle */}
                <div className="flex-shrink-0 flex items-center justify-center w-16 h-16 rounded-full bg-white border-2 border-primary z-10 relative shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-526">
                  <step.icon className="h-8 w-8 text-primary" data-id="element-527" />
                  <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-slate-900 text-white text-xs font-bold flex items-center justify-center" data-id="element-528">
                    {index + 1}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 bg-slate-50 rounded-xl p-6 border border-slate-100 hover:shadow-md transition-shadow duration-300" data-id="element-529">
                  <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-2" data-id="element-530">
                    <h3 className="text-xl font-bold text-slate-900" data-id="element-531">
                      {step.title}
                    </h3>
                    <div className="flex items-center gap-2" data-id="element-532">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-533">
                        {step.duration}
                      </span>
                    </div>
                  </div>

                  <p className="text-slate-600 mb-4 leading-relaxed" data-id="element-534">
                    {step.description}
                  </p>

                  <div className="flex items-center gap-2 text-sm font-medium text-slate-700 bg-white px-3 py-2 rounded-lg border border-slate-200 inline-block" data-id="element-535">
                    <span className="text-primary" data-id="element-536">Deliverable:</span>{' '}
                    {step.deliverable}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}